import React, { FC } from 'react'
import s from './RestaurantButtonKuper.module.sass'
import TitleKuper from '@icons/kuper/title-kuper.svg'
import { Button } from '@shared/ui/Actions/Button'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import Link from 'next/link'
import { Text } from '@shared/ui/Typography/Text'
import { AdvertBadge } from '@shared/ui/Feedback/AdvertBadge'
import AdvDetailed from '@features/Common/AdvDetailed/AdvDetailed'
import { offset } from '@floating-ui/react'

interface Props {
  data: {
    restName: string
    link: string
    description: string
    token: string
  }
  className?: string
}

const RestaurantButtonKuper: FC<Props> = ({ data, className = '' }) => {
  const { isMobile } = useClientResponsive()
  const handleClickTest = () => {
    console.log('click RestaurantButtonKuper component')
  }

  return (
    <ErrorBoundary>
      <Link href={data.link} className={s.link}>
        <Button sizes='XL' mode={isMobile ? 'black' : 'white'} className={s.button} onClick={handleClickTest}>
          <div className={s.left}>
            <Text className={s.text} sizes={'M S'}>
              Заказать доставку
            </Text>
            <TitleKuper className={s['kuper-title']} />
          </div>
          <div className={s.separator}></div>
          <div className={s.advert}>
            <AdvertBadge className={s.badge} sizes={'42x18'} />
            <AdvDetailed tooltipOptions={{ floatingMiddleware: [offset(20)] }}>
              <AdvDetailed.Button className={s['info-button']} iconChange={false} />
              <AdvDetailed.Tooltip description={data.description} token={data.token} />
            </AdvDetailed>
          </div>
        </Button>
      </Link>
    </ErrorBoundary>
  )
}

export default RestaurantButtonKuper
